// window.matchMedia('(min-width:768px)').matches
global.jQuery = require("jquery");
const $ = jQuery;
require('modaal');
let smoothscroll = require('smoothscroll-polyfill');
import './vendor/slick';
import { drawerMenu } from './component/drawerMenu';
// import { switchClassByHeight } from './component/scrollAction';
// import { setAutoHeight, getClientHeight, setWidthThumbnail, setHeightThumbnail, setJustHeight } from './helper/height';
import scroll from './component/scroll';

// ==========
// DOMツリー構築終了後に実行
// ==========
document.addEventListener('DOMContentLoaded', function() {
"use strict";
  
  // slick起動
  $(".use-slick").slick({
    autoplay: false,
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">前のエリア</button>',
    nextArrow: '<button type="button" class="slick-next">次のエリア</button>',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  })
  if ($(window).scrollTop() > 60) {
    $('#jsScrollHeader').addClass('fixed');
  } else {
    $('#jsScrollHeader').removeClass('fixed');
  }
}, false);

// ==========
// リサイズ処理
// ==========
let resizeTimeoutId; // リサイズイベントの頻度を減らす方法
window.addEventListener('resize',function(){
  "use strict";
  // setTimeout()がセットされていたら無視
	if ( resizeTimeoutId ) return ;
	resizeTimeoutId = setTimeout( function () {
    resizeTimeoutId = 0 ;

  }, 500);
}, false);

// ==========
// DOM、画像読み込み後に実行
// ==========
window.addEventListener('load',function(){
"use strict";

// スムーススクロール
// 参考：https://www.to-r.net/media/smooth_scrolling_2019/
  // ヘッダー要素
  let el_header = document.getElementById('navBtn');
  smoothscroll.polyfill();
  document.addEventListener("click", e => {
    scroll(e, el_header);
  })
  
  // ドロワーメニュー起動
  let el = document.getElementById('navBtn');
  el.addEventListener('click', () => {
    drawerMenu(el);
  })
  let close_menu  = document.getElementById('closeDrawerMenu');
  close_menu.addEventListener('click', () => {
    drawerMenu(el);
  })

  // モーダル初期化
  $('.open-modal').modaal({
    type: 'image',
    background: 'rgba(255,255,255)'
    // hide_close: true,
    // before_open: function() {
    //   console.log("表示するよ");
    // },
    // before_close: function(element) {
    //   stopVideo(element);
    // }  
  });
  // $('.c-modal__closeButton').on('click', function(element) {
  //   $('.open-modal').modaal('close');
  // })

}, false);

// ==========
// スクロール時に実行
// ==========
let scrollTimeoutId; // スクロールイベントの頻度を減らす方法
// スクロールジャンク防止の passive: true の設定
// IE11だけは第3引数にセットすると、別のプロパティ(useCapture)がtrueになるため、下記のコードで非対応ブラウザかどうか判定する。
// 参考URL：https://b.0218.jp/20180714221323.html
let passiveSupported = false;
try {
  window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: function() { passiveSupported = true; } }));
} catch(err) {}

passiveSupported = passiveSupported ? { passive: true } : false;

window.addEventListener('scroll', () => {
  // スクロールイベントの頻度を減らす。
  if (scrollTimeoutId) return;
  scrollTimeoutId = setTimeout( () => {
    scrollTimeoutId = 0 ;

    // let browseWidth = window.document.documentElement.clientWidth;
    // if(browseWidth > 1024) {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 60) {
          $('#jsScrollHeader').addClass('fixed');
        } else {
          $('#jsScrollHeader').removeClass('fixed');
        }
      })
    // }

    $('.effect-fade').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      // console.log(`scroll: ${scroll}`);
      // console.log(`elemPos - windowHeight: ${elemPos - windowHeight}`);
      if (scroll > elemPos  - (windowHeight / 1.5)){
        $(this).addClass('effect-scroll');
      }
  });

  }, 500);
}, passiveSupported);